import Footer from "../Footer";
import Header from "../Header";
import "../styles/thanks.scss";
import { useEffect, useState } from "react";
import { Modal } from "@mui/material";
import OfferModal from "./OfferModal";
import { useLocation } from 'react-router-dom';

export default function ThankYou() {
  const [offerModal, setOfferModal] = useState(false);
  const location = useLocation();

  useEffect(() => {
    //! OFFER BUMP MODAL FOR WHEN NEEDED
    //DETERMINE IF URL HAS A CUSTOMER ID AND IF DOES THEN PRESENT OFFER MODAL
    // const url = new URLSearchParams(window.location.search);
    // const customerId = url.get("customer_id");
    // console.log(customerId)
    // if (customerId) {
    //   //Check storage if modal already been opened
    //   let opened = localStorage.getItem("modal-opened");
    //   console.log(opened);
    //   if (!opened) {
    //     setOfferModal(true);
    //     localStorage.setItem("modal-opened", true);
    //   }
    // }
    if (window.fbq){
      window.fbq('track', 'Purchase');
    }
  }, [location]);

  return (
    <main className="thank__you">
      <Header page="thank-you" />
      <section className="thanks">
        <h2>Thank You!</h2>
        <p>
          Your materials have been sent to your email. Please check your inbox
          shortly.
        </p>
        <p>
          If you don't see the message, kindly check your spam or promotions
          folder.
        </p>
      </section>
      {/* MODALS */}
      {/* <Modal open={offerModal}>
        <OfferModal handleClose={setOfferModal} />
      </Modal> */}
    </main>
  );
}
